import { listChainRegistryEntries } from '@shared/chainRegistryClient'

export interface ContractChainOption {
  value: string
  label: string
  chainId: number
}

export const buildContractChainOptions = (
  mode: 'mainnet' | 'testnet'
): ContractChainOption[] => {
  const entries = listChainRegistryEntries()

  return entries
    .filter(entry => (mode === 'testnet' ? entry.isTestnet : !entry.isTestnet))
    .map(entry => ({
      value: entry.id,
      label: entry.name,
      chainId: entry.chainId,
    }))
    .sort((a, b) => a.label.localeCompare(b.label, 'en', { sensitivity: 'base' }))
}
